import { PersonExtended } from '@lib/user';
import { ApprovalStatus, IApprovalDto, IApproverGroup, ICustomerApproverDto } from '@lib/approval';

export class InvoiceApprovalInfo {
    public readonly groups: InvoiceApprovalGroup[];
    private readonly _approvalStatus: ApprovalStatus;

    public get nextPending(): InvoiceApprovalGroup | undefined {
        return ApprovalStatus.PENDING === this._approvalStatus
            ? this.groups.slice().find((entry) => entry.isPending)
            : undefined;
    }

    constructor(dto: IApprovalDto) {
        this.groups = dto.approverGroups.map((groupDto) => new InvoiceApprovalGroup(groupDto));
        this._approvalStatus = dto.approvalStatus;
    }
}

export class InvoiceApprovalGroup {
    public possibleApprovers: InvoiceApprovalEntry[];
    public readonly approvalsNeeded: number;
    public readonly name: string;
    private readonly _approvalStatus: ApprovalStatus;

    public get isPending(): boolean {
        return ApprovalStatus.PENDING === this._approvalStatus;
    }

    public get approvalsRemaining(): number {
        return this.approvalsNeeded - this.approvalsDone;
    }

    public get firstThreeApprovers(): InvoiceApprovalEntry[] {
        return this.possibleApprovers.filter((entry) => entry.isPending).slice(0, 3);
    }

    private get approvalsDone(): number {
        return this.possibleApprovers.filter((entry) => !entry.isPending).length;
    }

    constructor(dto: IApproverGroup) {
        this.possibleApprovers = dto.approvers.map((approverDto) => new InvoiceApprovalEntry(approverDto));
        this.approvalsNeeded = dto.approvalsNeeded;
        this.name = dto.name;
        this._approvalStatus = dto.approvalStatus;
    }
}

export class InvoiceApprovalEntry {
    public readonly approver: PersonExtended;
    public readonly approvedTimestamp: string;
    public readonly approvalStatus: ApprovalStatus;

    constructor(dto: ICustomerApproverDto) {
        this.approver = new PersonExtended(dto.customer);
        this.approvalStatus = dto.approvalStatus;
        this.approvedTimestamp = dto.date;
    }

    public get isPending(): boolean {
        return ApprovalStatus.PENDING === this.approvalStatus;
    }
}
